import { useMetricsFrameworkContext } from '../context/MetricsFrameworkContext';
import { useInsight } from '../hooks/useInsight';
import { useMetric } from '../hooks/useMetric';
import type { InsightResult, Section } from '../types';

const getInsightDisplayName = (data: InsightResult | null): string | undefined => {
  if (!data || !('display_name' in data) || typeof data.display_name !== 'string') {
    return undefined;
  }
  const trimmed = data.display_name.trim();
  return trimmed || undefined;
};

/** Resolves section header title — optional lift from sole metric/insight display_name. */
export const useSectionTitle = (section: Section): string | undefined => {
  const { filters } = useMetricsFrameworkContext();
  const soleItem =
    section.titleFromMetric && section.items.length === 1 ? section.items[0] : null;

  const soleMetricId = soleItem?.kind === 'metric' ? soleItem.id : '';
  const soleInsightId = soleItem?.kind === 'insight' ? soleItem.id : '';

  const { data: metricData } = useMetric(soleMetricId, filters, 'L1');
  const { data: insightData } = useInsight(soleInsightId, filters);

  if (!soleItem) {
    return section.title;
  }

  if (soleItem.kind === 'metric') {
    const fromMetric = metricData?.display_name?.trim();
    return fromMetric || undefined;
  }

  return getInsightDisplayName(insightData);
};
